import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { WaterIntake } from './model/water-intake';
import { Observable } from 'rxjs';
import { ApiService } from '@fitup-monorepo/core/lib/services/api/api.service';

@Injectable({
  providedIn: 'root',
})
export class WaterIntakeService {
  private readonly httpClient = inject(HttpClient);

  public getWaterIntake(): Observable<WaterIntake> {
    return this.httpClient.get<WaterIntake>(`${ApiService.API_URL}/water-intake`);
  }

  public addWaterIntake(amountMl: number, dailyGoalMl: number, glassSizeMl: number): Observable<WaterIntake> {
    return this.httpClient.put<WaterIntake>(`${ApiService.API_URL}/water-intake`, {
      ['amountMl']: amountMl,
      ['dailyGoalMl']: dailyGoalMl,
      ['glassSizeMl']: glassSizeMl,
    });
  }
}
